import axios from "axios";
import { Servidor } from "../../configuracion/apiUrls";
import { NegocioConfig } from "../../configuracion/Empresa";

/**
 * El backend pasó a exigir autenticación en todos los endpoints de datos:
 * sin token responde 401 {"error":"No autenticado"}. Antes no la exigía, asi
 * que buena parte del proyecto quedó usando AxiosPublico (que no manda
 * cabecera) contra rutas que ahora si la piden.
 *
 * En lugar de reemplazar las ~78 llamadas una por una, el token se adjunta
 * con un interceptor. Las rutas que de verdad son publicas —inicio de
 * sesión, envío de PIN, actualización de contraseña— siguen funcionando:
 * si no hay token guardado no se agrega ninguna cabecera.
 */

const CLAVE_TOKEN = "toke_almacenado" + NegocioConfig.sistema;

/** Lee el token de localStorage. useLocalStorage lo guarda serializado. */
const leerToken = () => {
    try {
        const valor = window.localStorage.getItem(CLAVE_TOKEN);
        if (!valor) return null;
        const token = JSON.parse(valor);
        return typeof token === "string" && token.length > 0 ? token : null;
    } catch (e) {
        // Modo privado, almacenamiento bloqueado o valor corrupto.
        return null;
    }
};

/**
 * Adjunta el token si existe y si la petición no trae ya una cabecera propia.
 * Los `defaults.headers.common` que fijan los contextos se mezclan antes de
 * los interceptores, asi que esa asignación explícita sigue teniendo
 * prioridad y no se pisa.
 */
const adjuntarToken = (instancia) => {
    instancia.interceptors.request.use((config) => {
        const yaTiene =
            config.headers?.Authorization || config.headers?.authorization;

        if (!yaTiene) {
            const token = leerToken();
            if (token) {
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    });

    return instancia;
};

export const AxiosPublico = adjuntarToken(
    axios.create({
        baseURL: Servidor,
        timeout: 10000,
        headers: { "Content-Type": "application/json" },
    })
);

export const AxiosPrivado = adjuntarToken(
    axios.create({
        baseURL: Servidor,
        timeout: 10000,
        headers: { "Content-Type": "application/json" },
    })
);

export const AxiosImagen = adjuntarToken(
    axios.create({
        baseURL: Servidor,
        timeout: 10000,
        headers: { "Content-Type": "multipart/form-data" },
    })
);
